(function () {
  'use strict';

  if (window.__senfinecoVinSearchLoaded) return;
  window.__senfinecoVinSearchLoaded = true;

  var STORAGE_KEY = 'sfSparePartsVehicleV1';
  var VIN_STORAGE_KEY = 'sfSparePartsVinV1';
  var REQUEST_TIMEOUT = 12000;
  var PUBLIC_DECODER = 'https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValuesExtended/';
  var AR =
    document.documentElement.dir === 'rtl' ||
    (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;

  var copy = AR
    ? {
        invalid: 'أدخل رقم شاصي صحيحًا من 17 خانة بدون I أو O أو Q.',
        removed: 'تم حذف خانة غير مستخدمة في أرقام الشاصي.',
        loading: 'جاري التحقق…',
        submit: 'اعرض القطع المطابقة',
        notFound: 'تعذر التعرف على رقم الشاصي. لن نخمن السيارة.',
        unsupported: 'هذه السيارة غير مدعومة حاليًا. الخدمة متاحة لتويوتا ولكزس فقط.',
        provider: 'تعذر الاتصال بخدمة الشاصي الآن. جرّب لاحقًا أو اختر السيارة يدويًا.',
        insufficient: 'البيانات المستلمة غير كافية لتأكيد السيارة. اخترها يدويًا.',
        switchManual: 'اختيار السيارة يدويًا',
        decoded: 'تم التعرف على السيارة',
        vinEnding: 'آخر 4 خانات',
        make: 'الماركة',
        model: 'الموديل',
        year: 'السنة',
        engine: 'المحرك',
        transmission: 'الجير',
        chassis: 'كود الهيكل',
        market: 'السوق',
        results: 'القطع المطابقة المتوفرة',
        resultCount: 'منتج',
        verified: 'مطابق للشاصي',
        confirm: 'يوجد أكثر من خيار — يحتاج تأكيد',
        unavailable: 'غير متوفر حاليًا',
        evidenceOem: 'مطابقة مؤكدة عبر رقم OEM',
        evidenceCatalog: 'مطابقة مؤكدة عبر بيانات الكتالوج',
        view: 'عرض المنتج',
        add: 'أضف إلى السلة',
        request: 'طلب توفير القطعة',
        emptyTitle: 'غير متوفر حاليًا',
        emptyNote: 'لم نجد قطعًا متوفرة في متجر سنفينكو ومطابقة لهذه السيارة.',
        imageAlt: 'صورة المنتج',
        restoring: 'جاري استعادة نتائج السيارة المحفوظة…',
        linking: 'تم التعرف على السيارة. جاري ربطها بخيارات EasySearch…',
        linked: 'تم ربط السيارة. جاري عرض القطع المناسبة…',
        mapping: 'تم التعرف على السيارة، لكن يلزم إكمال الاختيار في EasySearch.',
        drive: 'نظام الدفع',
        trim: 'الفئة'
      }
    : {
        invalid: 'Enter a valid 17-character VIN without I, O or Q.',
        removed: 'A character not used in VINs was removed.',
        loading: 'Checking…',
        submit: 'Show matching parts',
        notFound: 'We could not decode this VIN. We will not guess the vehicle.',
        unsupported: 'This vehicle is not supported yet. VIN search is for Toyota and Lexus only.',
        provider: 'The VIN service is unavailable. Try again later or select the vehicle manually.',
        insufficient: 'The returned data is not sufficient to confirm the vehicle. Select it manually.',
        switchManual: 'Select vehicle manually',
        decoded: 'Vehicle identified',
        vinEnding: 'VIN ending',
        make: 'Make',
        model: 'Model',
        year: 'Year',
        engine: 'Engine',
        transmission: 'Transmission',
        chassis: 'Chassis code',
        market: 'Market',
        results: 'Available matching parts',
        resultCount: 'product',
        verified: 'VIN verified match',
        confirm: 'Multiple options — confirmation required',
        unavailable: 'Currently unavailable',
        evidenceOem: 'Confirmed by OEM number',
        evidenceCatalog: 'Confirmed by catalog data',
        view: 'View product',
        add: 'Add to cart',
        request: 'Request this part',
        emptyTitle: 'Currently unavailable',
        emptyNote: 'No in-stock Senfineco products were confirmed for this vehicle.',
        imageAlt: 'Product image',
        restoring: 'Restoring saved vehicle results…',
        linking: 'Vehicle identified. Linking it to EasySearch…',
        linked: 'Vehicle linked. Loading compatible parts…',
        mapping: 'Vehicle identified, but the EasySearch selection needs to be completed.',
        drive: 'Driveline',
        trim: 'Trim'
      };

  function normalize(value) {
    return String(value || '')
      .normalize('NFKD')
      .replace(/[\u064B-\u065F\u0670]/g, '')
      .replace(/[_\-–—/]+/g, ' ')
      .replace(/[^\p{L}\p{N}.]+/gu, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function safeParse(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (_error) {
      return fallback;
    }
  }

  function readVehicle() {
    try {
      var vehicle = safeParse(window.localStorage.getItem(STORAGE_KEY) || '', null);
      return vehicle && vehicle.label ? vehicle : null;
    } catch (_error) {
      return null;
    }
  }

  function saveVehicle(vehicle) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(vehicle));
    } catch (_error) {
      /* The VIN flow remains usable when storage is unavailable. */
    }
  }

  function readVin() {
    try {
      var vin = String(window.localStorage.getItem(VIN_STORAGE_KEY) || '').toUpperCase();
      return validVin(vin) ? vin : '';
    } catch (_error) {
      return '';
    }
  }

  function saveVin(vin) {
    if (!validVin(vin)) return;
    try {
      window.localStorage.setItem(VIN_STORAGE_KEY, vin);
    } catch (_error) {
      /* The customer can still search when private storage is unavailable. */
    }
  }

  function clearVin() {
    try {
      window.localStorage.removeItem(VIN_STORAGE_KEY);
    } catch (_error) {
      /* The visible form can still be cleared when storage is unavailable. */
    }
  }

  function supportedMake(value) {
    var make = normalize(value);
    return make === 'toyota' || make === 'lexus' || make === 'تويوتا' || make === 'لكزس';
  }

  function setHidden(element, hidden) {
    if (!element) return;
    element.hidden = hidden;
    element.setAttribute('aria-hidden', String(hidden));
  }

  function finishAutostart() {
    document.documentElement.classList.remove('sf-vin-autostarting');
  }

  function setMessage(root, message, kind) {
    var box = root.querySelector('[data-sf-vin-message]');
    if (!box) return;
    box.textContent = message || '';
    box.dataset.kind = kind || '';
    setHidden(box, !message);
  }

  function setManualFallback(root, visible) {
    setHidden(root.querySelector('[data-sf-vin-manual-fallback]'), !visible);
  }

  function setBusy(root, busy) {
    var button = root.querySelector('[data-sf-vin-submit]');
    var input = root.querySelector('[data-sf-vin-input]');
    root.setAttribute('aria-busy', String(busy));
    if (button) {
      button.disabled = busy;
      button.textContent = busy ? copy.loading : copy.submit;
    }
    if (input) input.disabled = busy;
  }

  function setTab(root, name) {
    var isVin = name !== 'manual';
    root.querySelectorAll('[data-sf-vin-tab]').forEach(function (button) {
      var active = button.dataset.sfVinTab === (isVin ? 'vin' : 'manual');
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', String(active));
      button.tabIndex = active ? 0 : -1;
    });
    setHidden(root.querySelector('[data-sf-vin-panel="vin"]'), !isVin);
    setHidden(root.querySelector('[data-sf-vin-panel="manual"]'), isVin);
    if (!isVin) {
      clearResults(root, true);
      window.setTimeout(function () {
        window.dispatchEvent(new Event('resize'));
        var firstSelect = root.querySelector('.easysearch-select-holder select');
        if (firstSelect) firstSelect.focus({ preventScroll: true });
      }, 0);
    }
  }

  function sanitizeInput(input, announce) {
    var before = String(input.value || '').toUpperCase();
    var after = before.replace(/[^A-Z0-9]/g, '').replace(/[IOQ]/g, '').slice(0, 17);
    if (after !== before && announce) {
      var root = input.closest('[data-sf-vin-root]');
      if (root) setMessage(root, copy.removed, 'info');
    }
    input.value = after;
    var owner = input.closest('[data-sf-vin-root]');
    var counter = owner ? owner.querySelector('[data-sf-vin-count]') : null;
    if (counter) counter.textContent = after.length + '/17';
    return after;
  }

  function validVin(value) {
    return /^[A-HJ-NPR-Z0-9]{17}$/.test(value);
  }

  function proxyUrl(root) {
    var value = (root.dataset.sfVinProxy || '').trim();
    return value || '/apps/senfineco-vin/decode';
  }

  async function callProxy(root, payload) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = window.setTimeout(function () {
      if (controller) controller.abort();
    }, REQUEST_TIMEOUT);
    try {
      var response = await fetch(proxyUrl(root), {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        referrerPolicy: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload),
        signal: controller ? controller.signal : undefined
      });
      if (!response.ok) throw new Error('VIN_PROVIDER_' + response.status);
      return await response.json();
    } finally {
      window.clearTimeout(timer);
    }
  }


  function meaningful(value) {
    var text = String(value || '').trim();
    return /^(?:|0|not applicable|n\/a|null)$/i.test(text) ? '' : text;
  }

  function publicEngineCandidates(row) {
    var displacement = meaningful(row.DisplacementL);
    var cylinders = meaningful(row.EngineCylinders);
    var engineModel = meaningful(row.EngineModel);
    var drive = meaningful(row.DriveType);
    var values = [];
    if (displacement && cylinders) {
      values.push(displacement + 'L ' + cylinders + ' Cylinder');
      values.push(displacement + 'L ' + cylinders + ' Cyl');
      values.push(displacement + 'L I' + cylinders);
      if (cylinders === '6' || cylinders === '8') values.push(displacement + 'L V' + cylinders);
    }
    if (displacement) values.push(displacement + 'L');
    if (engineModel) values.push(engineModel);
    if (drive) values = values.concat(values.map(function (value) { return value + ' ' + drive; }));
    return values.filter(Boolean);
  }

  function normalizePublicDecode(data) {
    var row = data && Array.isArray(data.Results) ? data.Results[0] : null;
    if (!row) return { ok: false, status: 'not_found' };
    var make = meaningful(row.Make);
    var model = meaningful(row.Model);
    var year = meaningful(row.ModelYear);
    if (!make || !model || !year) return { ok: false, status: 'insufficient' };
    var engines = publicEngineCandidates(row);
    var displayEngine = engines[0] || '';
    return {
      ok: true,
      status: 'ok',
      decoder: 'nhtsa-vpic',
      vehicle: {
        make: make,
        model: model,
        year: year,
        engine: displayEngine,
        transmission: meaningful(row.TransmissionStyle),
        driveType: meaningful(row.DriveType),
        trim: meaningful(row.Trim) || meaningful(row.Series),
        chassisCode: '',
        market: '',
        decoder: 'nhtsa-vpic',
        easySearchCandidates: {
          make: [make],
          model: [model, meaningful(row.Series), meaningful(row.Series2), meaningful(row.Trim)].filter(Boolean),
          year: [year],
          engine: engines
        }
      },
      matches: []
    };
  }

  async function callPublicDecoder(vin) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = window.setTimeout(function () {
      if (controller) controller.abort();
    }, REQUEST_TIMEOUT);
    try {
      var response = await fetch(PUBLIC_DECODER + encodeURIComponent(vin) + '?format=json', {
        method: 'GET',
        credentials: 'omit',
        cache: 'no-store',
        referrerPolicy: 'no-referrer',
        headers: { Accept: 'application/json' },
        signal: controller ? controller.signal : undefined
      });
      if (!response.ok) throw new Error('PUBLIC_VIN_PROVIDER_' + response.status);
      return normalizePublicDecode(await response.json());
    } finally {
      window.clearTimeout(timer);
    }
  }

  async function decodeVin(root, vin) {
    try {
      var proxyData = await callProxy(root, {
        vin: vin,
        locale: AR ? 'ar' : 'en',
        scope: 'vehicle_decode'
      });
      if (proxyData && (proxyData.vehicle || proxyData.decodedVehicle || proxyData.result)) return proxyData;
    } catch (_error) {
      /* The app proxy is optional; the public decoder is the no-cost fallback. */
    }
    return await callPublicDecoder(vin);
  }

  async function linkVehicleToEasySearch(vehicle, submit) {
    var api = window.senfinecoSpareParts;
    if (!api || typeof api.applyVehicle !== 'function') return { ok: false, step: 'widget' };
    return await api.applyVehicle(vehicle, { submit: submit !== false });
  }

  function vehicleFromResponse(data, vinLast4) {
    var source = data && (data.vehicle || data.decodedVehicle || data.result);
    if (!source || typeof source !== 'object') return null;
    var make = source.make || source.brand || '';
    var model = source.model || '';
    var year = source.year || source.modelYear || '';
    if (!supportedMake(make)) return { unsupported: true };
    if (!model || !year) return null;
    var vehicle = {
      version: 2,
      source: 'vin',
      providerVehicleId: String(source.providerVehicleId || source.vehicleId || source.id || ''),
      make: String(make),
      model: String(model),
      year: String(year),
      engine: String(source.engine || source.engineName || source.engineCode || ''),
      transmission: String(source.transmission || source.gearbox || source.transmissionCode || ''),
      chassisCode: String(source.chassisCode || source.frameCode || source.platformCode || ''),
      market: String(source.market || source.region || source.destination || ''),
      driveType: String(source.driveType || source.driveline || source.drive || ''),
      trim: String(source.trim || source.series || ''),
      decoder: String(source.decoder || data.decoder || ''),
      easySearchCandidates: source.easySearchCandidates || data.easySearchCandidates || {},
      vinLast4: String(vinLast4 || data.vinLast4 || '').slice(-4),
      updatedAt: new Date().toISOString()
    };
    vehicle.label = [vehicle.make, vehicle.model, vehicle.year, vehicle.engine].filter(Boolean).join(' · ');
    return vehicle;
  }

  function responseStatus(data) {
    var status = normalize(data && (data.status || data.code || data.errorCode));
    if (data && data.ok === true && !status) return 'ok';
    return status;
  }

  function showFailure(root, data) {
    var status = responseStatus(data);
    if (status.indexOf('unsupported') !== -1 || status.indexOf('not supported') !== -1) {
      setMessage(root, copy.unsupported, 'error');
    } else if (status.indexOf('not found') !== -1 || status.indexOf('invalid') !== -1 || status.indexOf('decode') !== -1) {
      setMessage(root, copy.notFound, 'error');
    } else {
      setMessage(root, copy.insufficient, 'error');
    }
    setManualFallback(root, true);
  }

  function appendSpec(list, label, value, direction) {
    if (!value) return;
    var item = document.createElement('div');
    var term = document.createElement('dt');
    var description = document.createElement('dd');
    term.textContent = label;
    description.textContent = value;
    if (direction) description.dir = direction;
    item.append(term, description);
    list.appendChild(item);
  }

  function paintVehicle(root, vehicle) {
    var card = root.querySelector('[data-sf-vin-vehicle]');
    if (!card || !vehicle) return;
    var title = card.querySelector('[data-sf-vin-vehicle-title]');
    var vin = card.querySelector('[data-sf-vin-last4]');
    var specs = card.querySelector('[data-sf-vin-specs]');
    if (title) title.textContent = vehicle.label;
    if (vin) vin.textContent = vehicle.vinLast4 ? '•••• ' + vehicle.vinLast4 : '';
    if (specs) {
      specs.replaceChildren();
      appendSpec(specs, copy.make, vehicle.make);
      appendSpec(specs, copy.model, vehicle.model);
      appendSpec(specs, copy.year, vehicle.year, 'ltr');
      appendSpec(specs, copy.engine, vehicle.engine);
      appendSpec(specs, copy.transmission, vehicle.transmission);
      appendSpec(specs, copy.chassis, vehicle.chassisCode, 'ltr');
      appendSpec(specs, copy.drive, vehicle.driveType);
      appendSpec(specs, copy.trim, vehicle.trim);
      appendSpec(specs, copy.market, vehicle.market);
    }
    setHidden(card, false);
  }

  function evidenceKind(match) {
    var evidence = match && (match.evidenceType || match.matchBasis || (match.evidence && match.evidence.type) || '');
    return normalize(evidence);
  }

  function matchState(match) {
    var raw = normalize(match && (match.state || match.status || match.matchStatus || ''));
    var evidence = evidenceKind(match);
    var product = (match && match.product) || match || {};
    if (raw.indexOf('unavailable') !== -1 || product.available === false) return 'unavailable';
    var verifiedState = raw === 'verified' || raw === 'matched' || (match && match.verified === true);
    var verifiedEvidence =
      evidence === 'oem' ||
      evidence === 'catalog' ||
      evidence === 'oem catalog' ||
      evidence === 'catalog oem' ||
      evidence === 'oem_number' ||
      evidence === 'catalog_data';
    return verifiedState && verifiedEvidence ? 'verified' : 'confirm';
  }

  function productUrl(product) {
    if (product.url) return product.url;
    if (!product.handle) return '';
    return '/products/' + encodeURIComponent(product.handle) + '?view=senfineco-spare-parts';
  }

  function numericVariantId(value) {
    var match = String(value || '').match(/(\d+)$/);
    return match ? match[1] : '';
  }

  function requestUrl(vehicle, product) {
    var text = AR
      ? 'أرغب بطلب توفير قطعة لسيارة ' + vehicle.label
      : 'I would like to request a part for ' + vehicle.label;
    if (vehicle.vinLast4) text += (AR ? ' — آخر 4 خانات: ' : ' — VIN ending: ') + vehicle.vinLast4;
    if (product && product.title) text += (AR ? ' — القطعة: ' : ' — Part: ') + product.title;
    return 'https://wa.me/96877555601/?text=' + encodeURIComponent(text);
  }

  function makeButtonLink(label, href, className) {
    var link = document.createElement('a');
    link.className = className;
    link.textContent = label;
    link.href = href;
    return link;
  }

  function buildProductCard(match, vehicle) {
    var product = (match && match.product) || match || {};
    var state = matchState(match);
    var article = document.createElement('article');
    article.className = 'sf-vin-product sf-vin-product--' + state;
    article.dataset.matchState = state;
    article.setAttribute('data-sf-vin-product', '');
    article.dataset.sfMainCategory = product.mainCategory || product.main_category || (match && (match.mainCategory || match.main_category)) || '';
    article.dataset.sfPartType = product.partType || product.productType || (match && (match.partType || match.productType)) || '';
    article.dataset.sfSubcategory = product.subcategory || product.subCategory || (match && (match.subcategory || match.subCategory)) || '';
    article.dataset.sfPartKey = product.partKey || product.part_key || (match && (match.partKey || match.part_key)) || '';
    article.dataset.sfMapZone = product.mapZone || product.map_zone || (match && (match.mapZone || match.map_zone)) || '';
    article.dataset.sfPosition = product.position || (match && match.position) || '';
    article.dataset.sfLocationStatus = product.locationStatus || product.location_status || (match && (match.locationStatus || match.location_status)) || '';
    article.dataset.sfProductId = String(product.id || product.productId || (match && match.productId) || '');
    article.dataset.sfPartNumber = product.partNumber || product.part_number || product.oemPrimary || product.sku || '';
    article.dataset.sfProductInfo = [
      product.title,
      product.productType,
      product.partType,
      match && match.partType
    ].filter(Boolean).join(' ');
    article.dataset.sfProductTags = Array.isArray(product.tags) ? product.tags.join('||') : (product.tags || '');

    var mediaLink = document.createElement(productUrl(product) ? 'a' : 'div');
    mediaLink.className = 'sf-vin-product__media';
    if (mediaLink.tagName === 'A') mediaLink.href = productUrl(product);
    if (product.imageUrl || (product.image && product.image.url)) {
      var image = document.createElement('img');
      image.loading = 'lazy';
      image.src = product.imageUrl || product.image.url;
      image.alt = product.imageAlt || product.title || copy.imageAlt;
      mediaLink.appendChild(image);
    } else {
      var placeholder = document.createElement('span');
      placeholder.textContent = product.oemPrimary || product.sku || 'OEM';
      mediaLink.appendChild(placeholder);
    }

    var body = document.createElement('div');
    body.className = 'sf-vin-product__body';
    var badge = document.createElement('span');
    badge.className = 'sf-vin-product__badge';
    badge.textContent = state === 'verified' ? copy.verified : state === 'unavailable' ? copy.unavailable : copy.confirm;

    var title = document.createElement('h3');
    var fullTitle = product.title || product.oemPrimary || product.sku || '';
    var shortTitle = String(fullTitle)
      .replace(/^SENFINECO\s*/i, '')
      .split(/\s*[|｜]\s*|\s+OEM\b/i)[0]
      .trim() || fullTitle;
    if (productUrl(product)) {
      var titleLink = document.createElement('a');
      titleLink.href = productUrl(product);
      titleLink.textContent = shortTitle;
      if (shortTitle !== fullTitle) titleLink.title = fullTitle;
      title.appendChild(titleLink);
    } else {
      title.textContent = shortTitle;
    }

    var facts = document.createElement('div');
    facts.className = 'sf-vin-product__facts';
    if (product.oemPrimary || (match && (match.oemPrimary || match.oem))) {
      var oem = document.createElement('span');
      oem.dir = 'ltr';
      oem.textContent = 'OEM ' + (product.oemPrimary || match.oemPrimary || match.oem);
      facts.appendChild(oem);
    }
    if (product.partType || (match && match.partType)) {
      var type = document.createElement('span');
      type.textContent = product.partType || match.partType;
      facts.appendChild(type);
    }
    if (state === 'verified') {
      var evidence = document.createElement('small');
      evidence.textContent = evidenceKind(match).indexOf('oem') !== -1 ? copy.evidenceOem : copy.evidenceCatalog;
      facts.appendChild(evidence);
    }

    var commerce = document.createElement('div');
    commerce.className = 'sf-vin-product__commerce';
    if (product.priceFormatted || product.price) {
      var price = document.createElement('strong');
      price.textContent = product.priceFormatted || product.price;
      commerce.appendChild(price);
    }

    var actions = document.createElement('div');
    actions.className = 'sf-vin-product__actions';
    var url = productUrl(product);
    if (url) actions.appendChild(makeButtonLink(copy.view, url, 'sf-vin-product__view'));

    var variantId = numericVariantId(product.variantId || product.selectedVariantId);
    var available = state !== 'unavailable' && product.available !== false;
    if (available && variantId) {
      var form = document.createElement('form');
      form.method = 'post';
      form.action = '/cart/add';
      form.className = 'sf-vin-product__add-form';
      form.setAttribute('data-sf-grid-cart', '');
      var idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'id';
      idInput.value = variantId;
      var quantity = document.createElement('input');
      quantity.type = 'hidden';
      quantity.name = 'quantity';
      quantity.value = '1';
      var returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      returnTo.value = window.location.pathname + window.location.search;
      var button = document.createElement('button');
      button.type = 'submit';
      button.className = 'sf-parts-card__cart';
      button.textContent = copy.add;
      form.append(idInput, quantity, returnTo, button);
      actions.appendChild(form);
    } else if (state === 'unavailable') {
      actions.appendChild(makeButtonLink(copy.request, requestUrl(vehicle, product), 'sf-vin-product__request'));
    }

    body.append(badge, title, facts, commerce, actions);
    article.append(mediaLink, body);
    return article;
  }

  function matchesFromResponse(data) {
    var matches = data && (data.matches || data.products || data.fitmentMatches);
    return Array.isArray(matches) ? matches : [];
  }

  function setOriginalGridHidden(hidden) {
    document.querySelectorAll('[data-sf-spare-parts-results]').forEach(function (grid) {
      setHidden(grid, hidden);
    });
  }

  function clearResults(root, keepVehicle) {
    var results = root.querySelector('[data-sf-vin-results]');
    var grid = root.querySelector('[data-sf-vin-products]');
    var empty = root.querySelector('[data-sf-vin-empty]');
    if (grid) grid.replaceChildren();
    if (empty) setHidden(empty, true);
    if (results) setHidden(results, true);
    var browser = root.closest('[data-sf-spare-parts-browser]');
    if (browser) browser.classList.remove('is-vin-results-active');
    setOriginalGridHidden(false);
    if (!keepVehicle) setHidden(root.querySelector('[data-sf-vin-vehicle]'), true);
  }

  function renderResults(root, vehicle, data, shouldScroll) {
    var results = root.querySelector('[data-sf-vin-results]');
    var grid = root.querySelector('[data-sf-vin-products]');
    var empty = root.querySelector('[data-sf-vin-empty]');
    var count = root.querySelector('[data-sf-vin-result-count]');
    var matches = matchesFromResponse(data);
    if (!results || !grid || !empty) return;

    grid.replaceChildren();
    matches.forEach(function (match) {
      grid.appendChild(buildProductCard(match, vehicle));
    });
    if (count) count.textContent = matches.length + ' ' + copy.resultCount + (matches.length === 1 ? '' : AR ? '' : 's');

    var request = empty.querySelector('[data-sf-vin-request]');
    if (request) request.href = requestUrl(vehicle);
    setHidden(empty, matches.length > 0);
    setHidden(grid, matches.length === 0);
    setHidden(results, false);

    var browser = root.closest('[data-sf-spare-parts-browser]');
    if (browser) browser.classList.add('is-vin-results-active');
    setOriginalGridHidden(true);

    if (shouldScroll !== false) {
      results.setAttribute('tabindex', '-1');
      results.focus({ preventScroll: true });
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  async function restoreSaved(root, vehicle) {
    if (!vehicle || vehicle.source !== 'vin') return;
    paintVehicle(root, vehicle);
    try {
      await linkVehicleToEasySearch(vehicle, false);
    } catch (_error) {
      /* Keep the identified vehicle visible; the customer can complete EasySearch manually. */
    }
  }

  async function submitVin(root, vin) {
    var navigating = false;
    setBusy(root, true);
    setMessage(root, '', '');
    setManualFallback(root, false);
    clearResults(root, false);
    try {
      var data = await decodeVin(root, vin);
      var status = responseStatus(data);
      if (!(data && data.ok === true) && status !== 'ok' && status !== 'success') {
        showFailure(root, data || {});
        return;
      }

      var vehicle = vehicleFromResponse(data, vin.slice(-4));
      if (vehicle && vehicle.unsupported) {
        setMessage(root, copy.unsupported, 'error');
        setManualFallback(root, true);
        return;
      }
      if (!vehicle) {
        setMessage(root, copy.insufficient, 'error');
        setManualFallback(root, true);
        return;
      }

      saveVehicle(vehicle);
      saveVin(vin);
      paintVehicle(root, vehicle);
      document.dispatchEvent(new CustomEvent('sf:parts-vehicle-change', { detail: vehicle }));

      var matches = matchesFromResponse(data);
      if (matches.length) {
        renderResults(root, vehicle, data, true);
      } else {
        setMessage(root, copy.linking, 'info');
        var linked = await linkVehicleToEasySearch(vehicle, true);
        if (linked && linked.ok) {
          navigating = linked.navigating === true;
          setMessage(root, copy.linked, 'success');
        } else {
          setMessage(root, copy.mapping, 'info');
          setManualFallback(root, true);
        }
      }

    } catch (_error) {
      setMessage(root, copy.provider, 'error');
      setManualFallback(root, true);
    } finally {
      vin = '';
      setBusy(root, false);
      if (!navigating) finishAutostart();
    }
  }

  function init(root) {
    if (!root || root.dataset.sfVinReady === 'true') return;
    root.dataset.sfVinReady = 'true';
    setTab(root, 'manual');

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-sf-vin-tab]');
      if (tab) {
        event.preventDefault();
        setTab(root, tab.dataset.sfVinTab);
        return;
      }
      if (event.target.closest('[data-sf-vin-manual-fallback]')) {
        event.preventDefault();
        setTab(root, 'manual');
      }
    });

    var input = root.querySelector('[data-sf-vin-input]');
    if (input) {
      var savedVin = readVin();
      if (savedVin) input.value = savedVin;
      input.addEventListener('keydown', function (event) {
        if (event.key.length === 1 && !/[A-HJ-NPR-Z0-9]/i.test(event.key)) event.preventDefault();
      });
      input.addEventListener('input', function () {
        sanitizeInput(input, true);
      });
      sanitizeInput(input, false);
    }

    var form = root.querySelector('[data-sf-vin-form]');
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var vin = sanitizeInput(input, false);
        if (!validVin(vin)) {
          setMessage(root, copy.invalid, 'error');
          setManualFallback(root, true);
          if (input) input.focus();
          return;
        }
        submitVin(root, vin);
      });
    }

    var autoStartVin = false;
    try {
      autoStartVin = window.sessionStorage.getItem('sfSparePartsVinAutostartV1') === '1';
      if (autoStartVin) {
        window.sessionStorage.removeItem('sfSparePartsVinAutostartV1');
      }
    } catch (_error) {
      autoStartVin = false;
    }

    if (autoStartVin && form && input && validVin(sanitizeInput(input, false))) {
      setTab(root, 'vin');
      window.setTimeout(function () {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      }, 0);
    } else {
      if (autoStartVin) finishAutostart();
      restoreSaved(root, readVehicle());
    }
  }

  document.addEventListener('sf:parts-vehicle-change', function (event) {
    document.querySelectorAll('[data-sf-vin-root]').forEach(function (root) {
      var vehicle = event.detail || null;
      if (!vehicle) {
        clearVin();
        var input = root.querySelector('[data-sf-vin-input]');
        if (input) {
          input.value = '';
          sanitizeInput(input, false);
        }
        clearResults(root, false);
        return;
      }
      if (vehicle.source === 'easysearch' && !vehicle.decodedFromVin) {
        clearResults(root, true);
        setTab(root, 'manual');
      } else if (vehicle.source === 'vin' || vehicle.decodedFromVin) {
        paintVehicle(root, vehicle);
      }
    });
  });

  function boot(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('[data-sf-vin-root]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
